import * as React from "react";
import { ActionButton } from "@fluentui/react/lib/components/Button/ActionButton/ActionButton";
import { MessageBar, MessageBarType } from "@fluentui/react/lib/components/MessageBar";
import { Image, IImageProps } from "@fluentui/react/lib/Image";
import { CpbxApiHelper } from "../../helpers/CpbxApiHelper";
import { LocalCacheHelper } from "../../helpers/LocalCacheHelper";
import { ICpbxPhoneInteractionProps } from "./ICpbxPhoneInteractionProps";

class CpbxPhoneInteractionCallRetrieve extends React.Component<ICpbxPhoneInteractionProps> {

    private imagePropAnrfHeranholen: Partial<IImageProps> = {
        src: "/assets/Hero-Icons/Hero-Icon-Anruf-annehmen.svg"
    }

    private lcCpbxUn: string;
    private lcCpbxBa: string;
    private lcCpbxUserIv: string;
    private lcM365UserObjectId: string;
    private apiUrlFull: string;
    private reqHeaders: Headers;
    private interval;
    private delayBeforeUpdateInS: number;
    private defaultDelayBeforeResetMessagesInSec: number = 5;
    private delayBeforeResetMessagesInSec: number;
    private defaultShowActionAsDisabledInSec: number = 2;
    private showActionAsDisabledInSec: number;
    /* eslint-disable */
    constructor(props) {
        super(props);

        this.delayBeforeUpdateInS = 10;
    }

    /* eslint-enable */
    state = {
        hasCurrentCalls: true,
        isDoingAction: false,
        showWarningMessage: false,
        errOccured: false,
        errMsg: "",
        actionSucceeded: false
    }

    componentDidMount() {
        console.log("start componentDidMount CpbxPhoneInteractionCallRetrieve");
        this.lcCpbxUn = LocalCacheHelper.GetLocalStorageItemCbpxUserNameAsString();
        this.lcCpbxBa = LocalCacheHelper.GetLocalStorageItemCbpxUserBasicAuthStringAsString();

        // this.reqHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithAuth(this.lcCpbxBa);
        this.lcCpbxUserIv = LocalCacheHelper.GetLocalStorageItemCbpxUserIVString();
        this.lcM365UserObjectId = LocalCacheHelper.GetLocalStorageItemM365UserObjectId();
        this.reqHeaders = CpbxApiHelper.GetCpbxRequestHeadersWithAuthPsa(this.lcCpbxBa, this.lcM365UserObjectId, this.lcCpbxUserIv);

        // check delay-value has been passed as property-value
        this.delayBeforeResetMessagesInSec = this.defaultDelayBeforeResetMessagesInSec;
        if (this.props.hideDelayInSec !== undefined && this.props.hideDelayInSec >= 1 && this.props.hideDelayInSec <= 100) {
            this.delayBeforeResetMessagesInSec = this.props.hideDelayInSec;
        }
        console.log("this.delayBeforeResetMessagesInSec = '" + this.delayBeforeResetMessagesInSec + "'");

        // this.interval = setInterval(() => this.getCurrentCalls(), this.delayBeforeUpdateInS * 1000);

        // check delay-value has been passed as property-value
        this.showActionAsDisabledInSec = this.defaultShowActionAsDisabledInSec;
        if (this.props.showActionAsDisabledInSec !== undefined && this.props.showActionAsDisabledInSec >= 1 && this.props.showActionAsDisabledInSec <= 5) {
            this.showActionAsDisabledInSec = this.props.showActionAsDisabledInSec;
        }
        console.log("this.showActionAsDisabledInSec = '" + this.showActionAsDisabledInSec + "'");
    }

    componentWillUnmount() {
        console.log("start componentWillUnmount CpbxPhoneInteractionCallRetrieve");
        clearInterval(this.interval);
    }

    // not used at the moment
    getCurrentCalls() {
        console.log("start getCurrentCalls");

        this.apiUrlFull = CpbxApiHelper.GetCpbxUrlCalls(this.lcCpbxUn);
        // console.log("apiUrlFull='" + this.apiUrlFull + "'");

        this.setState({
            hasCurrentCalls: false,
            errOccured: false,
            errMsg: ""
        });

        fetch(this.apiUrlFull, {
            method: "GET",
            headers: this.reqHeaders,
            redirect: "follow"
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else if (response.status === 401) {
                    console.log("not authorised");

                    // simulate logout and reload the current page to avoid user-lock / user-deactivation
                    // hint: maybe the user changed the password in another system; we stored the (old) credentials
                    LocalCacheHelper.RemoveLocalCacheKeysForCbpxLogin();
                    localStorage.clear();
                    window.location.reload();
                } else {
                    throw new Error("Response not ok");
                }
            })
            .then(data => {
                // console.log("got data in getCurrentCalls");

                /* example response as json
                    {
                        "Calls": {
                            "@xmlns": {
                                "$": "http://schema.broadsoft.com/xsi"
                            },
                            "call": {
                                "@inConference": "false",
                                "callId": {
                                    "$": "callhalf-45021194831:0"
                                },
                                "uri": {
                                    "$": "/v2.0/user/axels@deutschland-lan.de/calls/callhalf-45021194831:0"
                                }
                            }
                        }
                    }
                */

                // check result
                // https://eslint.org/docs/rules/no-prototype-builtins
                // if (data.Calls.hasOwnProperty("call") === true) {
                if (Object.prototype.hasOwnProperty.call(data.Calls, "call") === true) {
                    console.log("at least one call found");
                    this.setState({
                        hasCurrentCalls: true
                    });
                } else {
                    console.log("no calls found");
                }
            })
            .catch(error => console.log("error", error));
    }

    private onClickCallRetrieve = (): void => {
        console.log("onClickCallRetrieve");
        this.doCpbxCallRetrieve();
    };

    // called by dismiss-button in message or automatically with a delay of xy seconds
    private resetSuccessMsg = (): void => {
        this.setState({
            actionSucceeded: false
        });
    }

    // called by dismiss-button in message or automatically with a delay of xy seconds
    private resetWarningMessage = (): void => {
        this.setState({
            showWarningMessage: false,
            errMsg: ""
        });
    }

    // called by dismiss-button in message or automatically with a delay of xy seconds
    private resetErrorMessage = (): void => {
        this.setState({
            errOccured: false,
            errMsg: ""
        });
    }

    doCpbxCallRetrieve() {
        console.log("start doCpbxCallRetrieve");
        this.apiUrlFull = CpbxApiHelper.GetCpbxUrlCallsCallRetrieve(this.lcCpbxUn);
        // console.log("apiUrlFull='" + this.apiUrlFull + "'");
        this.setState({
            isDoingAction: true
        });
        fetch(this.apiUrlFull, {
            method: "POST",
            headers: this.reqHeaders,
            redirect: "follow"
        })
            .then(response => {
                console.log("response.status='" + response.status + "'");
                if (response.ok) {
                    this.setState({
                        actionSucceeded: true,
                        showWarningMessage: false,
                        errOccured: false,
                        errMsg: ""
                    });
                    // hide success message automatically after a while
                    setTimeout(() => {
                        this.resetSuccessMsg();
                    }, this.delayBeforeResetMessagesInSec * 1000);
                    // change state after a while (per default the ringing action will start after 1 second)
                    // if you do not wait this will result in a quite strange ui-behaviour
                    setTimeout(() => {
                        this.setState({
                            isDoingAction: false
                        });
                    }, this.showActionAsDisabledInSec * 1000);
                    return response.json();
                } else if (response.status === 400) {
                    console.log("probably there is no call to retrieve.");
                    this.setState({
                        actionSucceeded: false,
                        isDoingAction: false,
                        showWarningMessage: true,
                        errOccured: false,
                        errMsg: "Es gibt kein laufendes Gespräch."
                    });
                    // hide warning message automatically after a while
                    setTimeout(() => {
                        this.resetWarningMessage();
                    }, this.delayBeforeResetMessagesInSec * 1000);
                } else {
                    this.setState({
                        actionSucceeded: false,
                        isDoingAction: false,
                        showWarningMessage: false,
                        errOccured: true,
                        errMsg: "Ein unerwarteter Fehler ist aufgetreten."
                    });
                    throw new Error("Response not ok");
                }
            })
            .then(data => {
                console.log("got data from doCpbxCallRetrieve");

                /* example response as xml
                    <?xml version="1.0" encoding="UTF-8"?>
                    <CallStartInfo xmlns="http://schema.broadsoft.com/xsi">
                        <callid>callhalf-1115:1</callid>
                        <externalTrackingId>40:1</externalTrackingId>
                    </CallStartInfo>

                    See docu > chapter 3.5.4.30:
                    This command is used to invoke the Call Retrieve function for the specified user. This
                    service effectively pulls the specified call for the target user from its current location to a
                    different location for the target user. The target user must have a multiple appearance
                    service active, such as BroadWorks Mobility, BroadWorks Anywhere, or Shared Call
                    Appearance. When the request is received, the Application Server emulates feature
                    access code (FAC) dialing by the user. A new call is originated as if the user dialed a
                    feature access code.

                    example response as json
                    {
                        "CallStartInfo": {
                            "@xmlns": {
                                "$": "http://schema.broadsoft.com/xsi"
                            },
                            "callId": {
                                "$": "callhalf-1115:1"
                            },
                            "externalTrackingId": {
                                "$": "40:1"
                            }
                        }
                    }
                */

                // for now do nothing; probably we could show a success-message (toast)
            })
            .catch(error => {
                console.log("error", error);
                // hide wanring message automatically after a while
                setTimeout(() => {
                    this.resetErrorMessage();
                }, this.delayBeforeResetMessagesInSec * 1000);
            });
    }

    render() {
        // preparing css-classes and title which depends on having current calls
        let cssClassNameBtn: string = "cpbxStartSiteContInnerButton";
        cssClassNameBtn += (this.state.hasCurrentCalls === true) ? " enabled" : " disabled";
        const titleBtn = (this.state.hasCurrentCalls === true) ? "Es gibt einen Anruf, der durch Klick herangeholt werden kann." : "Es gibt aktuell keinen Anruf, der herangeholt werden kann.";

        return (
            <div className="cpbxStartSiteContInnerDiv">
                <div className="cpbxStartSiteContInner">
                    <div className="cpbxStartSiteContInnerImgDiv">
                        <Image onClick={this.onClickCallRetrieve} className="cpbxStartSiteContInnerImg" {...this.imagePropAnrfHeranholen} alt="Anruf heranholen" />
                    </div>
                    <div className="cpbxStartSiteContInnerTitle">
                        Anruf heranholen
                    </div>
                    <div className='cpbxStartSiteContInnerText'>
                        <p>Übernehmen Sie ein laufendes Gespräch unterbrechungsfrei von einem Endgerät Ihres Arbeitsplatzes zu einem anderen.</p>
                    </div>
                </div>
                <div className=''>
                    <div className="cpbxStartSiteContInnerButtonCont" title={titleBtn}>
                        <ActionButton
                            onClick={this.onClickCallRetrieve}
                            disabled={!this.state.hasCurrentCalls || this.state.isDoingAction}
                            allowDisabledFocus
                            className={cssClassNameBtn}
                        >
                            {this.state.isDoingAction ? "Heranholen wird ausgeführt" : "Heranholen"}
                        </ActionButton>
                        {
                            // warning message
                            this.state.showWarningMessage && (
                                <MessageBar
                                    messageBarType={MessageBarType.warning}
                                    onDismiss={() => this.resetWarningMessage()}
                                    dismissButtonAriaLabel="Close"
                                    className="cpbxStartSiteContErrMsg"
                                >
                                    {this.state.errMsg}
                                </MessageBar>
                            )
                        }

                        {
                            // error message
                            this.state.errOccured && (
                                <MessageBar
                                    messageBarType={MessageBarType.error}
                                    onDismiss={() => this.resetErrorMessage()}
                                    dismissButtonAriaLabel="Close"
                                    className="cpbxStartSiteContErrMsg"
                                >
                                    {this.state.errMsg}
                                </MessageBar>
                            )
                        }

                        {
                            // success message
                            this.state.actionSucceeded && (
                                <MessageBar
                                    messageBarType={MessageBarType.success}
                                    onDismiss={() => this.resetSuccessMsg()}
                                    dismissButtonAriaLabel="Close"
                                    className="cpbxStartSiteContErrMsg"
                                >
                                    {"Anruf wurde erfolgreich herangeholt."}
                                </MessageBar>
                            )
                        }
                    </div>
                </div>
            </div>
        );
    }

}

export default CpbxPhoneInteractionCallRetrieve;
